
const Container = ({ children }) => {
    return (
        <div
            className="flex-grow"
            style={{
                maxWidth: "100vw", // 限制Row最大寬度
                overflow: "hidden", // 確保內容不超出範圍
            }}>
            {children}
        </div>
    );
};

export default Container
